
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PbaSecurityFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PbaSecurity"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pincode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"owned_by"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plot_area"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"construction_area"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valuation"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":167}};
    doc.loc.source = {"body":"fragment PbaSecurityFields on PbaSecurity {\n  id\n  address\n  city\n  state\n  country\n  pincode\n  property_type\n  owned_by\n  plot_area\n  construction_area\n  valuation\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/fragments/PbaSecurityFragment.graphql
// module id = 500
// module chunks = 0